import React from 'react';
import FormSelect from '../../common/FormSelect';
import { useTranslation } from 'react-i18next';

export interface YearFormSelectProps {
  year: number;
  years: number[];
  handleYearChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function YearFormSelect({ year, years, handleYearChange }: YearFormSelectProps) {
  const { t } = useTranslation();
  return (
    <>
      <FormSelect
        name="year"
        label={t('Year')}
        onChange={handleYearChange}
        defaultValue={year}
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </FormSelect>
    </>
  );
}
